export default __webpack_public_path__ + "static/RTDOSE-e6e397d64eca316f7cbf70acb649573b.gif";